<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button autoHide="true" data-cy="myLeads-hdr-menuBtn"></ion-menu-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <app-profile-component data-cy="myLeads-hdr-profileBtn" (click)="openMyProfile()"></app-profile-component>

      <ion-button *ngIf="!offlineOrStaleData || !loaded" (click)="openHelp()" data-cy="myLeads-hdr-helpBtn">
        <ion-icon slot="icon-only" name="help-circle-sharp"></ion-icon>
      </ion-button>

      <ion-button *ngIf="offlineOrStaleData && loaded" (click)="openOfflineModal()">
        <ion-icon slot="icon-only" name="cloud-offline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title data-cy="myLeads-hdr-title">Leads</ion-title>
  </ion-toolbar>

</ion-header>

<ion-content>

  <!-- OFFLINE INDICATOR -->
  <div (click)="openOfflineModal()" *ngIf="offlineOrStaleData && loaded" class="offlineDiv link">
    <span>Some leads may not display while offline <ion-icon name="cloud-offline-outline"></ion-icon></span>
  </div>

  <div class="myLeads" *ngIf="!showSkeleton && !loading">

    <div class="mainContentBoxFull blockBox">

      <div class="guests-content">

        <div class="guests-header">
          <div class="guest-header-title">
            <ion-label data-cy="myLeads-header-title">
              {{leadsTitle}}
            </ion-label>
          </div>

          
          <div class="guest-header-buttons">
            <!-- show different export options on native -->
            <span *ngIf="plt.is('cordova')">
              <ion-button class="share exportButtonIcon" *ngIf="plt.is('ios')" fill="clear" tappable (click)="share()">
                <ion-icon slot="icon-only" class="iconSize" name="share-outline"></ion-icon>
              </ion-button>
              <ion-button class="share exportButtonIcon" *ngIf="plt.is('android')" fill="clear" tappable
                (click)="share()">
                <ion-icon slot="icon-only" class="iconSize" name="share-social-outline"></ion-icon>
              </ion-button>

            </span>

            <!-- web just shows export button -->
            <ion-button class="exportButton share" *ngIf="!plt.is('cordova')" tappable (click)="share()"
              data-cy="myLeads-header-exportBtn">
              <ion-label>Export</ion-label>
            </ion-button>

            <ion-button fill="clear" (click)="openFilter($event)">
              <ion-icon name="options-outline"></ion-icon>
            </ion-button>

            <ion-select interface="popover" [interfaceOptions]="filterSelectOptions" (ionChange)="listingChange($event)"
              [(ngModel)]="selectedListing" class="address-ios-select" #filterSelect>
              <ion-select-option selected value="0">Select All</ion-select-option>
              <ion-select-option *ngFor="let address of searchRes" value="{{address.listingId}}">
                {{address.listings.address.title}}
              </ion-select-option>
            </ion-select>
          </div>

        </div>

        <div class="borderTopOnly">
          <div class="main-list-header">
            <div class="name-holder sticky-abs">
              <div class="name list-header sticky-abs" (click)="sort('name')" data-cy="myLeads-content-nameCol">
                Name
                <img src="assets/imgs/icn_sort_down.svg"
                  [class.hidden]="currentSortColumn !== 'name' || currentSortDir==='asc'"
                  data-cy="myLeads-content-name-ascBtn" />
                <img src="assets/imgs/icn_sort_up.svg"
                  [class.hidden]="currentSortColumn !== 'name' || currentSortDir==='desc'"
                  data-cy="myLeads-content-name-descBtn" />

              </div>
            </div>
            <div id="headerHolder" #headerHolder class="content-holder header-holder">
              <div class="stick-header-content">
                <div class="phone list-header" (click)="sort('phone')" data-cy="myLeads-content-phoneCol">
                  Phone
                  <img src="assets/imgs/icn_sort_down.svg"
                    [class.hidden]="currentSortColumn !== 'phone' || currentSortDir==='asc'"
                    data-cy="myLeads-content-phone-ascBtn" />
                  <img src="assets/imgs/icn_sort_up.svg"
                    [class.hidden]="currentSortColumn !== 'phone' || currentSortDir==='desc'"
                    data-cy="myLeads-content-phone-descBtn" />
                </div>
                <div class="email list-header" (click)="sort('email')" data-cy="myLeads-content-emailCol">
                  Email
                  <img src="assets/imgs/icn_sort_down.svg"
                    [class.hidden]="currentSortColumn !== 'email' || currentSortDir==='asc'"
                    data-cy="myLeads-content-email-ascBtn" />
                  <img src="assets/imgs/icn_sort_up.svg"
                    [class.hidden]="currentSortColumn !== 'email' || currentSortDir==='desc'"
                    data-cy="myLeads-content-email-descBtn" />
                </div>
                <div class="notes list-header" (click)="sort('notes')" data-cy="myLeads-content-notesCol">
                  Notes
                  <img src="assets/imgs/icn_sort_down.svg"
                    [class.hidden]="currentSortColumn !== 'notes' || currentSortDir==='asc'"
                    data-cy="myLeads-content-notes-ascBtn" />
                  <img src="assets/imgs/icn_sort_up.svg"
                    [class.hidden]="currentSortColumn !== 'notes' || currentSortDir==='desc'"
                    data-cy="myLeads-content-notes-descBtn" />
                </div>
                <div *ngIf="(userRole === 'lender' || userRole === 'agentAdmin')" class="agent list-header"
                  (click)="sort('agent')" data-cy="myLeads-content-agentCol">
                  Agent
                  <img src="assets/imgs/icn_sort_down.svg"
                    [class.hidden]="currentSortColumn !== 'agent' || currentSortDir === 'asc'"
                    data-cy="myLeads-content-agent-ascBtn" />
                  <img src="assets/imgs/icn_sort_up.svg"
                    [class.hidden]="currentSortColumn !== 'agent' || currentSortDir==='desc'"
                    data-cy="myLeads-content-agent-descBtn" />
                </div>
                <div class="address list-header" (click)="sort('address')" data-cy="myLeads-content-listingAddrCol">
                  Listing Address
                  <img src="assets/imgs/icn_sort_down.svg"
                    [class.hidden]="currentSortColumn !== 'address' || currentSortDir === 'asc'"
                    data-cy="myLeads-content-listingAddr-ascBtn" />
                  <img src="assets/imgs/icn_sort_up.svg"
                    [class.hidden]="currentSortColumn !== 'address' || currentSortDir==='desc'"
                    data-cy="myLeads-content-listingAddr-descBtn" />
                </div>
                <div class="source list-header" (click)="sort('source')" data-cy="myLeads-content-sourceCol">
                  Source
                  <img src="assets/imgs/icn_sort_down.svg"
                    [class.hidden]="currentSortColumn !== 'source' || currentSortDir==='asc'"
                    data-cy="myLeads-content-source-ascBtn" />
                  <img src="assets/imgs/icn_sort_up.svg"
                    [class.hidden]="currentSortColumn !== 'source' || currentSortDir==='desc'"
                    data-cy="myLeads-content-source-descBtn" />
                </div>
                <div class="date list-header" (click)="sort('date')" data-cy="myLeads-content-dateCol">
                  Lead Creation Date
                  <img src="assets/imgs/icn_sort_down.svg"
                    [class.hidden]="currentSortColumn !== 'date' || currentSortDir==='asc'"
                    data-cy="myLeads-content-date-ascBtn" />
                  <img src="assets/imgs/icn_sort_up.svg"
                    [class.hidden]="currentSortColumn !== 'date' || currentSortDir==='desc'"
                    data-cy="myLeads-content-date-descBtn" />
                </div>
              </div>
            </div>
          </div>
          <div class="main-list-container">

            <!-- non synced leads display-->
            <ion-list class="main-list non-synced-list" *ngIf="offlineLeads && offlineLeads.length > 0" (click)="showOfflineSyncWarning()">
              <div class="name-column-holder">
                <div *ngFor="let guest of offlineLeads" class="list-item faded-row">
                  <div class="name-holder sticky-abs">
                    <div tappable class="name list-item-content">
                      <div class="non-synced-icon pad-left-5" data-cy="myLeads-content-nonSynced-name-icon">
                        <ion-icon name="cloud-offline-outline" class="crossed-cloud"></ion-icon>
                      </div>
                      <div class="label fullName" data-cy="myLeads-content-nonSynced-name-value" *ngIf="!guest.isMask"
                        [ngClass]="guest.guest.partialLead ? 'partialLead' : ''">
                        {{guest?.guest.fullName}}
                      </div>
                      <div data-cy="myLeads-content-nonSynced-name-value" *ngIf="guest.isMask"
                        class="overlay-mask-name"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="main-list-content" #nonSyncedBodyHolder id="nonSyncedBodyHolder">
                <div *ngFor="let guest of offlineLeads" class="list-item faded-row">
                  <div class="content-holder" id="nonSynced-content-holder">
                    <div tappable class="phone list-item-content">
                      <div *ngIf="!guest.isMask" class="label" data-cy="myLeads-content-nonSynced-phone-value"
                        [ngClass]="guest.guest.partialLead ? 'partialLead' : ''">
                        {{common.formatPhone(guest.guest.phoneNumber, guest.guest.phoneCountryCode)}}
                      </div>
                      <div data-cy="myLeads-content-nonSynced-phone-value" *ngIf="guest.isMask" class="overlay-mask">
                      </div>
                    </div>
                    <div tappable class="email list-item-content">
                      <div *ngIf="!guest.isMask" class="label" data-cy="myLeads-content-nonSynced-email-value"
                        [ngClass]="guest.guest.partialLead ? 'partialLead' : ''">
                        {{guest?.guest.email}}
                      </div>
                      <div data-cy="myLeads-content-nonSynced-email-value" *ngIf="guest.isMask" class="overlay-mask">
                      </div>
                    </div>
                    <div tappable class="notes list-item-content">
                      <div class="label" data-cy="myLeads-content-nonSynced-notes-value"
                        [ngClass]="guest.guest.partialLead ? 'partialLead' : ''">
                        {{guest?.guest.notes}}
                      </div>
                    </div>
                    <!-- Agent column - if needed -->
                    <div *ngIf="(userRole === 'lender' || userRole === 'agentAdmin')" class="agent list-item-content">
                      <div class="label">
                        <!-- No agent information for offline leads -->
                      </div>
                    </div>
                    <div tappable class="address list-item-content">
                      <div class="label" data-cy="myLeads-content-nonSynced-listingAddr-value"
                        [ngClass]="guest.guest.partialLead ? 'partialLead' : ''">
                        <!-- Display listing address if available -->
                        <span *ngIf="guest?.listings?.address?.title">{{guest?.listings?.address?.title}}</span>
                        <span *ngIf="!guest?.listings?.address?.title">-</span>
                      </div>
                    </div>
                    <div tappable class="source list-item-content">
                      <div class="label" data-cy="myLeads-content-nonSynced-source-value"
                        [ngClass]="guest.guest.partialLead ? 'partialLead' : ''">
                        {{guest?.guest?.source}}
                      </div>
                    </div>
                    <div tappable class="date list-item-content">
                      <div class="label" data-cy="myLeads-content-nonSynced-date-value"
                        [ngClass]="guest.guest.partialLead ? 'partialLead' : ''">
                        {{guest?.createdAt}} {{guest?.time}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ion-list>
            <!-- end of non synced leads-->

            <ion-list class="main-list">
              <div class="name-column-holder">
                <div *ngFor="let guest of finalResPaginated" class="list-item">
                  <div class="name-holder sticky-abs">
                    <div tappable (click)="onGuestClick(guest)" class="name list-item-content">
                      <app-guest-item [guest]="guest" class="pad-left-5" data-cy="myLeads-content-name-profImg">
                      </app-guest-item>
                      <div class="label fullName" data-cy="myLeads-content-name-value" *ngIf="!guest.isMask"
                        [ngClass]="guest.guest.partialLead ? 'partialLead' : ''">
                        {{guest?.guest.fullName}}
                      </div>

                      <div data-cy="myLeads-content-name-value" *ngIf="guest.isMask" class="overlay-mask-name"></div>


                    </div>
                  </div>
                </div>
              </div>
              <div class="main-list-content" #bodyHolder id="bodyHolder">
                <div *ngFor="let guest of finalResPaginated" class="list-item">
                  <div class="content-holder" id="content-holder">
                    <div tappable (click)="onGuestClick(guest)" class="phone list-item-content">
                      <div *ngIf="!guest.isMask" class="label" data-cy="myLeads-content-phone-value"
                        [ngClass]="guest.guest.partialLead ? 'partialLead' : ''">
                        {{common.formatPhone(guest.guest.phoneNumber, guest.guest.phoneCountryCode)}}
                      </div>

                      <div data-cy="myLeads-content-phone-value" *ngIf="guest.isMask" class="overlay-mask"></div>

                    </div>
                    <div tappable (click)="onGuestClick(guest)" class="email list-item-content">
                      <div *ngIf="!guest.isMask" class="label" data-cy="myLeads-content-email-value"
                        [ngClass]="guest.guest.partialLead ? 'partialLead' : ''">
                        {{guest?.guest.email}}
                      </div>
                      <div data-cy="myLeads-content-email-value" *ngIf="guest.isMask" class=" overlay-mask"></div>


                    </div>
                    <div tappable (click)="onGuestClick(guest)" class="notes list-item-content">
                      <div class="label" data-cy="myLeads-content-notes-value"
                        [ngClass]="guest.guest.partialLead ? 'partialLead' : ''">
                        {{guest?.guest.notes}}
                      </div>

                    </div>
                    <div *ngIf="(userRole === 'lender' || userRole === 'agentAdmin')" tappable
                      (click)="onGuestClick(guest)" class="agent list-item-content">
                      <app-profile-image-item *ngIf="guest.listingAgent" class="agentAvatar"
                        [profile]="guest.listingAgent" data-cy="myLeads-content-agent-profImg">
                      </app-profile-image-item>
                      <div *ngIf="guest.listingAgent" class="label" data-cy="myLeads-content-agentUsername-value">
                        {{guest?.listingAgent.username}}
                      </div>
                    </div>
                    <div *ngIf="guest.listings.address" tappable (click)="onGuestClick(guest)"
                      class="address list-item-content">
                      <div class="label" data-cy="myLeads-content-listingAddr-value"
                        [ngClass]="guest.guest.partialLead ? 'partialLead' : ''">
                        {{guest?.listings.address.title}}
                      </div>
                    </div>
                    <div tappable (click)="onGuestClick(guest)" class="source list-item-content">
                      <div class="label" data-cy="myLeads-content-source-value"
                        [ngClass]="guest.guest.partialLead ? 'partialLead' : ''">
                        {{guest?.guest.source}}
                      </div>
                    </div>
                    <div tappable (click)="onGuestClick(guest)" class="date list-item-content">
                      <div class="label" data-cy="myLeads-content-date-value"
                        [ngClass]="guest.guest.partialLead ? 'partialLead' : ''">
                        {{guest?.signInTime | date: 'medium'}}
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </ion-list>

            <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)">
              <ion-infinite-scroll-content loadingSpinner="crescent"></ion-infinite-scroll-content>
            </ion-infinite-scroll>


            <div class="rawleads-container">
              <p *ngIf="cordova">Want to see the leads that didn't complete the entire sign-in? <ion-icon
                  color="primary" tappable (click)="leadPartialInfo()" ios="information-circle-sharp"
                  md="information-circle-sharp"></ion-icon>
              </p>
              <p *ngIf="finalRes.length > 400">Still not seeing all your leads? We auto-archive older leads but you can
                retrieve them by <a class="bold link" href="mailto:support@curbhe.ro?Subject=Support"
                  target="_top">emailing support</a>
              </p>
            </div>

          </div>
        </div>
      </div>

      <div *ngIf="showRefresh" class="refresh-holder">
        <ion-button ion-button (click)="refreshPage()">Refresh</ion-button>
      </div>

    </div>
  </div>

  <!-- LENDER VIEW -->
  <div *ngIf="(userRole === 'lender' || userRole === 'agentAdmin') && showSkeleton && !showRefresh && !loading"
    class="skeleton-holder">
    <div class="noLeadsDiv blockBox centerBox centerAlign">
      <img src="/assets/imgs/newListingsIcon.png" data-cy="myLeads-empty-icon" />
      <div class="label" data-cy="myLeads-empty-lbl">
        Want to see the Curb Hero lead activity from your team? Start by inviting them. <strong
          (click)="learnMore()">Learn more</strong>
      </div>
      <ion-button ion-button tappable (click)="getStarted()" color="primary" data-cy="myLeads-empty-getStartedBtn">
        Get Started
      </ion-button>
    </div>
  </div>

  <!-- AGENT VIEW -->
  <div *ngIf="userRole === 'agent' && showSkeleton && !showRefresh && !loading" class="skeleton-holder">
    <div class="noLeadsDiv blockBox centerBox centerAlign">
      <img src="/assets/imgs/empty_listing.svg" data-cy="myLeads-empty-icon" />
      <div class="label" data-cy="myLeads-empty-lbl">
        No Leads Yet
      </div>
      <ion-button ion-button tappable (click)="getStarted()" color="primary" data-cy="myLeads-empty-getStartedBtn">
        Get Started
      </ion-button>
    </div>
  </div>

  <div *ngIf="loading" class="skeleton-holder">
    <div class="noLeadsDiv blockBox centerBox centerAlign">
      <ion-label>Loading</ion-label>
      <div class="padding">
        <ion-spinner name="crescent"></ion-spinner>
      </div>
    </div>
  </div>


</ion-content>